<template>
    <div class="text">
        <slot></slot>
        <div class="text-mask"></div>
    </div>
</template>

<script>
    import { reactive, toRefs, computed } from 'vue'

    //文字高光划过特效
    export default {
        name: 'TextTransition1',
        props: {
        },
        setup: (props, context) => {
            const state = reactive({
                props,
            })

            return {
                ...toRefs(state),
            }
        }
    }
</script>

<style scoped lang="scss">
    .text {
        position: relative;
        display: inline-block;
        overflow: hidden;
    }

    .text-mask {
        width: 10px;
        height: 100%;
        background: rgba(255,255,255,0.8);
        /*backdrop-filter: blur(10px);*/
        display: inline-block;
        position: absolute;
        left: -10px;
        animation-name: anima-text-mask;
        animation-duration: 5s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    @keyframes anima-text-mask {
        100% {
            left: 1500%;
        }
    }
</style>